module.exports = __webpack_public_path__ + "static/media/pic_fengxiang.e9e38e10.png";